// Демо-данные окна «Шаблоны» (Snippets) для главной Hub.
// Шаблон — сохранённый ответ: название, короткий ID для вызова через «/», текст, тема и файлы.
import { t } from "@/lib/i18n";

export const snippetsNav = [
  {
    group: t("Рабочее пространство"),
    items: [
      { id: "dashboard", label: t("Дашборд"), icon: "ri-dashboard-line" },
      { id: "general", label: t("Общие сведения"), icon: "ri-information-line" },
      { id: "user-settings", label: t("Настройки пользователей"), icon: "ri-user-settings-line" },
      { id: "team-settings", label: t("Настройки команды"), icon: "ri-team-line" },
      { id: "apps", label: t("Приложения"), icon: "ri-apps-line" },
      { id: "channels", label: t("Каналы"), icon: "ri-share-forward-line" },
      { id: "integrations", label: t("Интеграции"), icon: "ri-links-line" },
      { id: "widgets", label: t("Виджеты"), icon: "ri-layout-grid-line" },
    ],
  },
  {
    group: t("Настройки входящих"),
    items: [
      { id: "contact-fields", label: t("Поля контактов"), icon: "ri-contacts-book-2-line" },
      { id: "lifecycle", label: t("Жизненный цикл"), icon: "ri-refresh-line" },
      { id: "conversations", label: t("Диалоги"), icon: "ri-chat-3-line" },
      { id: "snippets", label: t("Шаблоны"), icon: "ri-file-copy-2-line" },
      { id: "tags", label: t("Теги"), icon: "ri-price-tag-3-line" },
      { id: "ai-assist", label: "AI Assist", icon: "ri-sparkling-line" },
      { id: "ai-prompts", label: "AI Prompts", icon: "ri-question-answer-line" },
      { id: "calls", label: t("Звонки"), icon: "ri-phone-line" },
    ],
  },
  {
    group: t("Данные"),
    items: [
      { id: "files", label: t("Файлы"), icon: "ri-folder-line" },
      { id: "import", label: t("Импорт контактов"), icon: "ri-upload-cloud-2-line" },
      { id: "data-export", label: t("Экспорт данных"), icon: "ri-download-cloud-2-line" },
    ],
  },
];

// разделы, до которых в макете реально можно доскроллить
export const snippetsNavAnchors: Record<string, string> = {
  dashboard: "#dashboard",
  "contact-fields": "#fields",
  lifecycle: "#lifecycle",
  conversations: "#conversations",
  tags: "#tags",
  "ai-assist": "#ai-assist",
  "ai-prompts": "#ai-prompts",
  "ai-knowledge": "#ai-knowledge",
  channels: "#channels",
  widgets: "#widgets",
  calls: "#catalog",
  import: "#contacts-import",
  "data-export": "#data-export",
  "user-settings": "#user-settings",
  "team-settings": "#team-settings",
};

// темы — ключи (по ним фильтр и сравнение в snippets.tsx); на экране показываются через t(topic)
export const snippetTopics = ["Поддержка", "Продажи", "Оплата", "Доставка"];

export const snippets = [
  {
    id: "s-greeting",
    name: t("Приветствие"),
    fieldId: "greeting",
    message: t("Привет, $contact.firstName! Меня зовут Анна, я из команды Hub. Чем можем помочь?"),
    topic: "Поддержка",
    files: [],
    updated: "2026-10-27",
  },
  {
    id: "s-prices",
    name: t("Прайс и условия"),
    fieldId: "price",
    message: t(
      "Отправляю актуальный прайс на 2026 год. Тариф «Команда» — 1 490 ₽ за пользователя в месяц, при оплате за год скидка 20%. Если удобно, соберу расчёт под вашу команду.",
    ),
    topic: "Продажи",
    files: ["price-2026.pdf"],
    updated: "2026-10-26",
  },
  {
    id: "s-payment",
    name: t("Реквизиты для оплаты"),
    fieldId: "invoice",
    message: t(
      "Счёт готов и приложен к сообщению. Оплатить можно по ссылке из документа, назначение платежа менять не нужно. После оплаты пришлите, пожалуйста, платёжное поручение — сразу закроем доступ.",
    ),
    topic: "Оплата",
    files: ["invoice-template.pdf", "requisites.txt"],
    updated: "2026-10-23",
  },
  {
    id: "s-delivery",
    name: t("Сроки подключения"),
    fieldId: "delivery",
    message: t(
      "Номер WhatsApp подключается по QR-коду за 2–3 минуты, Telegram — по токену бота. Если нужна помощь с настройкой, наш инженер подключится к созвону в течение рабочего дня.",
    ),
    topic: "Доставка",
    files: [],
    updated: "2026-10-21",
  },
  {
    id: "s-demo",
    name: t("Приглашение на демо"),
    fieldId: "demo",
    message: t(
      "Предлагаю 30 минут демо: покажу единую ленту WhatsApp и Telegram, переназначение диалогов и шаблоны ответов. Когда вам удобно — завтра в 11:00 или в 16:00?",
    ),
    topic: "Продажи",
    files: ["demo-checklist.pdf"],
    updated: "2026-10-18",
  },
  {
    id: "s-thanks",
    name: t("Закрытие диалога"),
    fieldId: "thanks",
    message: t("Спасибо за обращение! Если появятся вопросы — просто ответьте в этом чате, мы на связи в рабочее время."),
    topic: "Поддержка",
    files: [],
    updated: "2026-10-14",
  },
];
